import { render, staticRenderFns } from "./serviceCommentPreview.vue?vue&type=template&id=42788b28&scoped=true&"
import script from "./serviceCommentPreview.vue?vue&type=script&lang=js&"
export * from "./serviceCommentPreview.vue?vue&type=script&lang=js&"
import style0 from "./serviceCommentPreview.vue?vue&type=style&index=0&id=42788b28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42788b28",
  null
  
)

export default component.exports